import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';

export const ArticleTextContentLoadDetailsActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[article/text-content] Load details'),
  requestFail: uniqueActionType('[article/text-content] Load details fail'),
  requestSuccess: uniqueActionType('[article/text-content] Load details success'),
  requestClearErrors: uniqueActionType('[article/text-content] Load details clear errors'),
  requestClear: uniqueActionType('[article/text-content] Load details clear')
};

export class ArticleTextContentLoadDetailsAction implements PayloadAction {
  readonly type = ArticleTextContentLoadDetailsActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class ArticleTextContentLoadDetailsFailAction implements PayloadAction {
  readonly type = ArticleTextContentLoadDetailsActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class ArticleTextContentLoadDetailsSuccessAction implements PayloadAction {
  readonly type = ArticleTextContentLoadDetailsActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class ArticleTextContentLoadDetailsClearAction implements PayloadAction {
  readonly type = ArticleTextContentLoadDetailsActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}

export class ArticleTextContentLoadDetailsClearErrorsAction implements PayloadAction {
  readonly type = ArticleTextContentLoadDetailsActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}
